import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass";

var BaseStore = /*#__PURE__*/function () {
  function BaseStore(scope) {
    _classCallCheck(this, BaseStore);

    this.scope = scope;
  }

  _createClass(BaseStore, [{
    key: "getData",
    value: function getData(id) {
      var storageData = null;
      var storageStr = window["".concat(this.scope, "Storage")].getItem(id);

      try {
        storageData = JSON.parse(storageStr);
      } catch (e) {
        storageData = {};
      }

      return storageData;
    }
  }, {
    key: "save",
    value: function save(id, value) {
      window["".concat(this.scope, "Storage")].setItem(id, value);
    }
  }, {
    key: "destroy",
    value: function destroy(id) {
      window["".concat(this.scope, "Storage")].removeItem(id);
    }
  }]);

  return BaseStore;
}();

var PREFIX = 'e';
var VERSION = '1.1';
/** *
 * 存储类，
 */

var EasyStore = /*#__PURE__*/function () {
  /** *
     *
     * @param id storeId
     * @param expiresTime 默认缓存时间(单位:毫秒)，不传默认为null,永久保存
     * @param scope 缓存类型 session,local(默认session)
     */
  function EasyStore(id, scope) {
    _classCallCheck(this, EasyStore);

    if (!id) {
      throw Error('miss store id');
    }

    this.data = {};
    this.store = null;
    this.id = "".concat(PREFIX, "_").concat(VERSION, "_").concat(id);
    this.scope = scope || 'session';
    this.store = new BaseStore(this.scope);
    this.loadData(); // this.expires = arguments[1] ? (Date.now() + arguments[1]) : null;
  }
  /** *
     * 加载/初始化数据
     * @private
     */


  _createClass(EasyStore, [{
    key: "loadData",
    value: function loadData() {
      try {
        var storageData = _objectSpread({
          data: {}
        }, this.store.getData(this.id));

        this.data = storageData.data;
      } catch (e) {
        console.error(e);
      }
    }
    /** *
       * 是否过期
       * @private
       */

  }, {
    key: "isExpires",
    value: function isExpires(expires) {
      return expires && new Date(expires).getTime() < Date.now();
    }
    /**
       * 保存数据
       * @private
       */

  }, {
    key: "save",
    value: function save() {
      var saveStr = JSON.stringify({
        data: this.data
      });
      this.store.save(this.id, saveStr);
    }
    /**
       * 清空数据
       */

  }, {
    key: "clear",
    value: function clear() {
      this.data = {};
      this.save();
    }
    /** *
       * 设置缓存值
       * @param key
       * @param value
       * @param expiresTime
       */

  }, {
    key: "set",
    value: function set(key, value, expiresTime) {
      var expires = expiresTime;
      expires = expires ? Date.now() + expires : null;
      this.data[key] = {
        value: value,
        expires: expires
      };
      this.save();
    }
    /** *
       * 根据key获取数据
       * @param key
       * @returns {null}
       */

  }, {
    key: "get",
    value: function get(key) {
      var _ref = this.data[key] || {},
          expires = _ref.expires,
          value = _ref.value;

      return this.isExpires(expires) ? null : value;
    }
    /**
       * 判断是否存在key
       * @param key
       */

  }, {
    key: "has",
    value: function has(key) {
      return key in this.data;
    }
    /**
       * 删除指定的key
       * @param key
       */

  }, {
    key: "remove",
    value: function remove(key) {
      if (this.has(key)) {
        delete this.data[key];
        this.save();
      }
    }
    /** *
       * 迭代器
       * @param callback key,value
       */

  }, {
    key: "forEach",
    value: function forEach(callback) {
      var _this = this;

      var data = this.data;
      Object.keys(data).forEach(function (key) {
        var _ref2 = data[key] || {},
            value = _ref2.value,
            expires = _ref2.expires;

        key in data && !_this.isExpires(expires) && typeof callback === 'function' && callback.call(_this, key, value);
      });
    }
    /** *
       * 销毁
       */

  }, {
    key: "destroy",
    value: function destroy() {
      this.store.destroy(this.id);
      this.store = null;
      this.data = null;
    }
  }]);

  return EasyStore;
}();

export default EasyStore;